import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from 'components/common/Icon/Icon'
import PhoneLink from 'components/common/PhoneLink'
import Media from 'components/common/Media'

const SpecialOrder = ({
  formattedStorePhoneNumber,
  storePhoneNumber,
  morePadding
}) =>
  <Wrapper morePadding={ morePadding }>
    <SpecialOrderLabel>
      <SpecialOrderIcon asset="special-order" />
      Special Order
    </SpecialOrderLabel>
    Available today to 3 days, please call &nbsp;
    <Media.Mobile>
      <MobilePhoneLink number={ storePhoneNumber } />
    </Media.Mobile>
    <Media.Desktop>
      <PhoneNumber>{ formattedStorePhoneNumber }</PhoneNumber>
    </Media.Desktop>
    &nbsp; to confirm.
  </Wrapper>

export default SpecialOrder

SpecialOrder.propTypes = {
  formattedStorePhoneNumber: PropTypes.string,
  morePadding: PropTypes.bool,
  storePhoneNumber: PropTypes.string
}

const Wrapper = styled.div`
  padding-bottom: ${props => props.morePadding ? '24px' : '10px'};
  font-size: 12px;
  line-height: 22px;
  overflow-wrap: break-word;
`

const SpecialOrderIcon = styled(Icon)`
  width: 20px;
  margin-right: 5px;
  ${Media.mobile`
    margin-top: -4px;
  `}
`

const SpecialOrderLabel = styled.span`
  text-transform: uppercase;
  white-space: nowrap;
  font-weight: bold;
  margin-right: 3px;
`

const PhoneNumber = styled.span`
  font-size: 12px;
  white-space: nowrap;
`

const MobilePhoneLink = styled(PhoneLink)`
  font-size: 12px;
  white-space: nowrap;
`
